import 'bootstrap';
import { Mobile } from './core'
import  './modules/products-form'
import  './modules/profile-form'

$(document).ready(function() {
  /* Mobile toggle */
  const mobileChecker = new Mobile(1023)
  mobileChecker.addCallbacks(function() {
    $('table').addClass('table-responsive')
  }, function() {
    $('table').removeClass('table-responsive')
  })

  /* Bootstrap dropdown */
  $('.dropdown-toggle').dropdown()

  /* Mobile menu */
  $('button.burger').on('click', function() {
    if ($(this).data('opened') === true) {
      $(this).data('opened', false)
      $(this).find('.fas').removeClass('fa-times').addClass('fa-lines')
      $('.nav').removeClass('nav--opened')
    } else {
      $(this).data('opened', true)
      $(this).find('.fas').removeClass('fa-lines').addClass('fa-times')
      $('.nav').addClass('nav--opened')
    }
  })

  /* Products form */
  $('.order-form').each(function() {
    $(this).ProductsForm()
  })

  /* Profile forms */
  $('.user-form--register, .user-form--profile').each(function() {
    $(this).ProfileForm()
  })

  /* Remove updated param */
  window.history.replaceState({}, document.title, location.href.substr(0, location.href.indexOf('?')));
})
